var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-editor',{staticClass:"appup-editor",class:{'border border-danger': _vm.state==false },attrs:{"id":_vm.id,"placeholder":_vm.placeholder},on:{"imageAdded":_vm.onChange},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/inputs/editor/editor.vue